import TransactionView from '../../components/TransactionView'
import { TransactionType } from '../../../../graphql'
import getColumns from 'views/reports/columns'
import { useFlags } from '@equipmentshare/feature-flags'

export default function OutgoingPartsTransfers(): JSX.Element {
	const variables = { transactionTypes: TransactionType.StoreToStore }
	const flags = useFlags()
	const columns = getColumns( true, flags.enableTswWeightedAverageCost )

	return (
		<TransactionView
			title="Outgoing Transfers"
			heaperPageTitle="Outgoing Parts Transfers"
			variables={variables}
			storeIdsKey="fromIds"
			columns={columns}
		/>
	)
}
